import { render, staticRenderFns } from "./StaffDetails.vue?vue&type=template&id=5c574961&"
import script from "./StaffDetails.vue?vue&type=script&lang=js&"
export * from "./StaffDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c574961')) {
      api.createRecord('5c574961', component.options)
    } else {
      api.reload('5c574961', component.options)
    }
    module.hot.accept("./StaffDetails.vue?vue&type=template&id=5c574961&", function () {
      api.rerender('5c574961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffs/StaffDetails.vue"
export default component.exports